import { AbstractOverlay } from "@lib/titan2/dist/game/view/display/AbstractOverlay";
/**
 * Overlay.ts
 */
export class Overlay extends AbstractOverlay {
    constructor(factory, properties, portraitProperties) {
        super(properties, portraitProperties);
        this.createFactory(factory);
        this.run();
    }
    createFactory(factory) {
        this.factory = factory;
    }
    createModel() {
        this.model = this.factory.getModel();
    }
    registerGame(event, handler) {
        this.model.register(event, handler, this);
    }
    unregisterGame(event) {
        this.model.unregister(event, this);
    }
    dispatchGame(event) {
        this.model.dispatch(event);
    }
}
//# sourceMappingURL=Overlay.js.map